<template>
    <div class="menu-page">

        <!-- ===== Header cu identitate ===== -->
        <header class="m-hero">
            <div class="m-topbar">

                <div class="m-lang" v-click-outside="close_lang">
                    <button class="m-lang-btn" @click="langOpen = !langOpen" aria-label="Schimbă limba">
                        <img class="flag-icon" :src="get_flag_image(CurrentLang)" alt=""/> {{ CurrentLang }}
                    </button>
                    <div class="m-lang-list" v-if="langOpen">
                        <button v-for="l in Languages" :key="l" @click="schimba_limba(l)">
                            <img class="flag-icon" :src="get_flag_image(l)" alt=""/> {{ l }}
                        </button>
                    </div>
                </div>

                <div class="m-actions">
                    <button class="m-iconbtn" @click="toggle_theme" :title="theme === 'dark' ? 'Mod de zi' : 'Mod de seară'" aria-label="Comută modul de seară">
                        <span v-if="theme === 'dark'">☀</span>
                        <span v-else>☾</span>
                    </button>
                    <button class="m-iconbtn" @click="arata_filtre_dialog" title="Filtru alergeni" aria-label="Deschide filtrul de alergeni">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
                            <line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/>
                        </svg>
                    </button>
                </div>
            </div>

            <h1 class="m-name serif">{{ Info.NumeLocatie }}</h1>
            <div class="m-sub">MENIU DIGITAL</div>
        </header>

        <!-- ===== Bara de categorii, sticky ===== -->
        <nav class="m-cats" ref="catsBar" aria-label="Categorii">
            <button v-for="c in Info.Categorii"
                    :key="'cat-chip-' + c.Id"
                    :ref="'chip-' + c.Id"
                    class="m-cat"
                    :class="{active: activeCat == c.Id}"
                    @click="scroll_to_categorie(c.Id)">
                {{ c.Nume | translate_in_language(CurrentLang) }}
            </button>
        </nav>

        <!-- ===== Alergeni exclusi ===== -->
        <div class="m-excl" v-if="Filtre.AlergeniSelectati.length > 0">
            Excludem:
            <span class="tag" v-for="(a, idx) in Filtre.AlergeniSelectati" :key="'a-'+idx">{{ a.Nume }}</span>
            <button @click="reset_filtre">resetează</button>
        </div>

        <!-- ===== Listare ===== -->
        <main class="m-list">
            <section class="m-section"
                     v-for="c in Info.Categorii"
                     :key="'categorie-' + c.Id"
                     :id="'cat-' + c.Id"
                     :ref="'cat-' + c.Id">
                <h2 class="serif" v-reveal="0">
                    {{ c.Nume | translate_in_language(CurrentLang) }}
                    <span class="cnt">{{ c.Retete.length }} preparate</span>
                </h2>

                <article class="m-card"
                         v-for="(r, ri) in c.Retete"
                         v-reveal="ri"
                         :key="'reteta-' + r.Id"
                         tabindex="0"
                         role="button"
                         @click="arata_detaliu(r)"
                         @keydown.enter.prevent="arata_detaliu(r)"
                         @keydown.space.prevent="arata_detaliu(r)">
                    <div class="lft">
                        <div class="tt serif">{{ r.Nume | translate_in_language(CurrentLang) }}</div>
                        <div class="ds">{{ r.Descriere | translate_in_language(CurrentLang) }}</div>
                        <div class="meta">
                            <span class="g" v-if="r.CantitateInfo">{{ r.CantitateInfo }}</span>
                            <span class="m-al" v-for="(a, idx) in r.Alergeni.slice(0, 2)" :key="'al-'+idx">{{ a.Nume }}</span>
                            <span class="m-al" v-if="r.Alergeni.length > 2">+{{ r.Alergeni.length - 2 }}</span>
                        </div>
                    </div>
                    <div class="rgt">
                        <img class="m-img" v-if="are_imagine(r)" :src="r.ImagePreview" :alt="''" loading="lazy"/>
                        <div class="m-price" v-if="arat_preturi">{{ r.Pret | money_format }}<small>lei</small></div>
                    </div>
                </article>
            </section>
        </main>

        <!-- ===== Footer ===== -->
        <footer class="m-foot">
            <a class="m-anpc" v-reveal="0" :href="'https://valorinutritie.ro/meniu-anpc/' + token">
                <span class="arr">→</span>
                <b>Declarația nutrițională completă</b>
                <span>Meniul ANPC cu valorile pentru fiecare preparat</span>
            </a>
            <div class="m-power">meniu realizat cu <a href="https://valorinutritie.ro">valorinutritie.ro</a></div>
        </footer>

        <!-- ===== Detaliu preparat ===== -->
        <BottomSheet ref="dlgDetaliu">
            <div v-if="Detaliu">
                <img class="d-img" v-if="are_imagine(Detaliu)" :src="Detaliu.ImagePreview" :alt="''"/>
                <div class="d-head">
                    <h4 class="serif">{{ Detaliu.Nume | translate_in_language(CurrentLang) }}</h4>
                    <div class="m-price" v-if="arat_preturi">{{ Detaliu.Pret | money_format }}<small>lei</small></div>
                </div>
                <div class="d-line" v-if="Detaliu.CantitateInfo">{{ Detaliu.CantitateInfo }}</div>
                <p class="d-desc">{{ Detaliu.Descriere | translate_in_language(CurrentLang) }}</p>
                <div class="d-tags" v-if="Detaliu.Alergeni.length > 0">
                    <span class="m-al" v-for="(a, idx) in Detaliu.Alergeni" :key="'da-'+idx">{{ a.Nume }}</span>
                </div>
            </div>
        </BottomSheet>

        <FiltreDialog ref="dlgFiltre" @save="on_change_filtre"/>
    </div>
</template>

<script>

import BasePage from '@/pages/BasePage.vue';
import settings from '@/backend/LocalSettings';
import FiltreDialog from '@/pages/dialogs/FiltreDialog.vue';
import BottomSheet from '@/components/BottomSheet.vue';

/* observer unic pentru animatiile de reveal la scroll */
var revealObserver = null;
function get_reveal_observer(){
    if( revealObserver == null ){
        revealObserver = new IntersectionObserver( function(entries){
            entries.forEach( function(e){
                if( e.isIntersecting ){
                    e.target.classList.add('revealed');
                    revealObserver.unobserve(e.target);
                    //dupa animatie scoatem clasele, ca stilurile normale (ex :active) sa nu fie afectate
                    e.target.addEventListener('transitionend', function handler(){
                        e.target.classList.remove('will-reveal', 'revealed');
                        e.target.style.transitionDelay = '';
                        e.target.removeEventListener('transitionend', handler);
                    });
                }
            });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 } );
    }
    return revealObserver;
}
function reveal_este_activ(){
    return 'IntersectionObserver' in window
        && !( window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches );
}

export default {
    name: "HomePage",
    components: {FiltreDialog, BottomSheet},
    extends: BasePage,
    directives: {
        //animatie de reveal cand elementul intra in viewport
        'reveal': {
            inserted(el, binding) {
                if( !reveal_este_activ() ) return;
                el.classList.add('will-reveal');
                el.style.transitionDelay = ((binding.value || 0) % 6) * 45 + 'ms';
                get_reveal_observer().observe(el);
            },
            unbind(el) {
                if( revealObserver != null ) revealObserver.unobserve(el);
            }
        },
        //inchide dropdownul de limba la click in afara lui
        'click-outside': {
            bind(el, binding) {
                el.__clickOutside__ = (e) => {
                    if (!el.contains(e.target)) binding.value();
                };
                document.addEventListener('click', el.__clickOutside__);
            },
            unbind(el) {
                document.removeEventListener('click', el.__clickOutside__);
                delete el.__clickOutside__;
            }
        }
    },
    data: function() {
        return {
            Info: {
                NumeLocatie: "",
                Categorii:[],
                AfisezPreturiVanzareLaQR: '0'
            },
            Filtre:{
                AlergeniSelectati: []
            },
            Languages: [],
            CurrentLang: "RO",
            langOpen: false,
            theme: 'light',
            activeCat: null,
            Detaliu: null
        }
    },
    computed: {
        token() {
            return this.$route.params.token
        },
        arat_preturi() {
            return this.Info.AfisezPreturiVanzareLaQR === '1';
        }
    },
    methods:{
      async refresh_info() {
          var response = await this.post("meniu/get_info_meniu_digital", {token: this.token, filtre: this.Filtre});
          this.Info    = response.Info;
          if( this.Info.Categorii.length > 0 && this.activeCat == null ){
              this.activeCat = this.Info.Categorii[0].Id;
          }
      },
      are_imagine(r){
          return r.Imagine != null && r.Imagine !== "";
      },
      arata_detaliu(r){
          this.Detaliu = r;
          this.$refs.dlgDetaliu.open();
      },
      arata_filtre_dialog(){
        this.$refs.dlgFiltre.show_me( this.Filtre.AlergeniSelectati );
      },
      on_change_filtre(alergeni_selectati){
        this.Filtre.AlergeniSelectati = alergeni_selectati;
        this.refresh_info();
      },
      schimba_limba(l){
        this.CurrentLang = l;
        this.langOpen    = false;
      },
      close_lang(){
        this.langOpen = false;
      },
      get_flag_image(l){
        var lowerL = l.toLowerCase();
        return `https://www.valorinutritie.ro/assets/images/flags/${lowerL}.svg`;
      },
      reset_filtre(){
        this.Filtre.AlergeniSelectati = [];
        this.refresh_info();
      },

      /* ===== tema zi / seara ===== */
      apply_theme(t){
        this.theme = t;
        document.documentElement.setAttribute('data-theme', t);
      },
      toggle_theme(){
        var next = this.theme === 'dark' ? 'light' : 'dark';
        this.apply_theme(next);
        try { localStorage.setItem('vn-menu-theme', next); } catch(e) { /* safari private mode */ }
      },
      init_theme(){
        var saved = null;
        try { saved = localStorage.getItem('vn-menu-theme'); } catch(e) { /* safari private mode */ }
        if( saved === 'dark' || saved === 'light' ){
            this.apply_theme(saved);
        } else if( window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ){
            this.apply_theme('dark');
        }
      },

      /* ===== navigare pe categorii + scroll-spy ===== */
      scroll_to_categorie(id){
        var el = (this.$refs['cat-' + id] || [])[0];
        if(!el) return;
        var top = el.getBoundingClientRect().top + window.pageYOffset - 58;
        window.scrollTo({top: top, behavior: 'smooth'});
      },
      on_window_scroll(){
        if( this.Info.Categorii.length === 0 ) return;
        var pos     = window.pageYOffset + 90;
        var current = this.Info.Categorii[0].Id;
        for(var i = 0; i < this.Info.Categorii.length; i++){
            var c  = this.Info.Categorii[i];
            var el = (this.$refs['cat-' + c.Id] || [])[0];
            if( el && (el.getBoundingClientRect().top + window.pageYOffset) <= pos ){
                current = c.Id;
            }
        }

        //la finalul paginii activam ultima categorie, altfel nu ar deveni activa niciodata
        var laFinal = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4;
        if( laFinal ){
            current = this.Info.Categorii[this.Info.Categorii.length - 1].Id;
        }
        if( current === this.activeCat ) return;
        this.activeCat = current;

        //centram chipul activ, derulam DOAR bara de categorii, niciodata pagina
        var bar  = this.$refs.catsBar;
        var chip = (this.$refs['chip-' + current] || [])[0];
        if( bar && chip ){
            var left = chip.offsetLeft - (bar.clientWidth - chip.offsetWidth) / 2;
            bar.scrollTo({left: Math.max(0, left), behavior: 'smooth'});
        }
      }
    },
    mounted() {
        this.Languages = settings.LANGUAGES;
        this.init_theme();
        this.refresh_info();
        window.addEventListener('scroll', this.on_window_scroll, {passive: true});
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.on_window_scroll);
    }
  }
  </script>

<style lang="less" scoped>
.menu-page {
    max-width: 560px;
    margin: 0 auto;
    min-height: 100vh;
}

/* ===== animatii de reveal ===== */
.will-reveal {
    opacity: 0;
    transform: translateY(14px);

    &.revealed {
        opacity: 1;
        transform: translateY(0);
        transition: opacity .5s ease, transform .5s ease;
    }
}

/* intrarea heroului la incarcare */
@keyframes hero-in {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
}
.m-name  { animation: hero-in .5s ease both; }
.m-sub   { animation: hero-in .5s ease .08s both; }

@media (prefers-reduced-motion: reduce) {
    .m-name, .m-sub { animation: none; }
    .will-reveal { opacity: 1; transform: none; }
}

/* ===== hero ===== */
.m-hero {
    background: linear-gradient(160deg, var(--m-hero1), var(--m-hero2));
    color: var(--m-hero-ink);
    padding: 22px 20px;
    position: relative;
    /* fara overflow:hidden - ar taia dropdownul de limba */

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        pointer-events: none;
        background: radial-gradient(120% 90% at 85% -10%, rgba(244, 241, 230, .14), transparent 55%);
    }

    .m-topbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        z-index: 40; /* peste bara sticky de categorii (30), altfel dropdownul de limba apare dedesubt */
        margin-bottom: 18px;
    }

    .m-name {
        font-size: 30px;
        line-height: 1.1;
        font-weight: 600;
        margin: 0;
        position: relative;
        z-index: 2;
    }

    .m-sub {
        position: relative;
        z-index: 2;
        margin-top: 6px;
        font-size: 11px;
        letter-spacing: .14em;
        color: var(--m-hero-ink);
        opacity: .65;
    }
}

.m-lang {
    position: relative;

    .m-lang-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(244, 241, 230, .13);
        border: 1px solid rgba(244, 241, 230, .25);
        color: var(--m-hero-ink);
        border-radius: 99px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: .06em;
        padding: 6px 12px;
        cursor: pointer;
    }

    .m-lang-list {
        position: absolute;
        top: calc(100% + 6px);
        left: 0;
        z-index: 40; /* peste bara sticky de categorii (30) */
        background: var(--m-card);
        border: 1px solid var(--m-line);
        border-radius: 14px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, .16);
        overflow: hidden;
        min-width: 92px;

        button {
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100%;
            background: none;
            border: none;
            padding: 9px 14px;
            font-size: 13px;
            font-weight: 600;
            color: var(--m-ink);
            cursor: pointer;

            &:hover {
                background: var(--m-chip);
            }
        }
    }
}

.flag-icon {
    width: 16px;
    border-radius: 2px;
}

.m-actions {
    display: flex;
    gap: 8px;
}

.m-iconbtn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(244, 241, 230, .13);
    border: 1px solid rgba(244, 241, 230, .25);
    color: var(--m-hero-ink);
    font-size: 15px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

/* ===== bara de categorii ===== */
.m-cats {
    position: sticky;
    top: 0;
    z-index: 30;
    background: var(--m-bg);
    border-bottom: 1px solid var(--m-line);
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.m-cat {
    flex: 0 0 auto;
    font-size: 13px;
    font-weight: 600;
    padding: 7px 14px;
    border-radius: 99px;
    background: var(--m-chip);
    color: var(--m-muted);
    border: none;
    cursor: pointer;
    white-space: nowrap;
    transition: background .2s, color .2s;

    &.active {
        background: var(--m-accent);
        color: var(--m-accent-ink);
    }
}

/* ===== alergeni exclusi ===== */
.m-excl {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    padding: 10px 16px 0;
    font-size: 12px;
    color: var(--m-muted);

    .tag {
        background: var(--m-chip);
        border: 1px solid var(--m-line);
        border-radius: 99px;
        padding: 2px 9px;
        font-weight: 600;
        color: var(--m-ink);
    }

    button {
        background: none;
        border: none;
        color: var(--m-accent);
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        padding: 2px 4px;
        text-decoration: underline;
    }
}

/* ===== listare ===== */
.m-list {
    padding: 0 16px;
}

.m-section {
    h2 {
        font-size: 21px;
        font-weight: 600;
        margin: 22px 0 4px;
        display: flex;
        align-items: baseline;
        gap: 10px;

        .cnt {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            font-size: 11px;
            font-weight: 600;
            color: var(--m-muted);
            letter-spacing: .08em;
            text-transform: uppercase;
        }
    }
}

.m-card {
    background: var(--m-card);
    border: 1px solid var(--m-line);
    border-radius: 18px;
    padding: 14px;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    transition: transform .15s ease;

    &:active {
        transform: scale(.985);
    }

    .lft {
        flex: 1;
        min-width: 0;
    }

    .tt {
        font-size: 16.5px;
        font-weight: 600;
        line-height: 1.25;
    }

    .ds {
        font-size: 12.5px;
        color: var(--m-muted);
        margin-top: 4px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .meta {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        margin-top: 9px;

        .g {
            font-size: 11.5px;
            color: var(--m-muted);
            font-variant-numeric: tabular-nums;
        }
    }

    .rgt {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .m-card {
        transition: none;

        &:active {
            transform: none;
        }
    }
}

.m-al {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .03em;
    background: var(--m-chip);
    color: var(--m-muted);
    border-radius: 99px;
    padding: 2px 8px;
    white-space: nowrap;
}

.m-img {
    width: 92px;
    height: 76px;
    border-radius: 14px;
    object-fit: cover;
    background: var(--m-img-bg);
    border: 1px solid var(--m-line);
}

.m-price {
    font-size: 15px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;

    small {
        font-size: 11px;
        font-weight: 600;
        color: var(--m-muted);
        margin-left: 3px;
    }
}

/* ===== footer ===== */
.m-foot {
    padding: 26px 16px 30px;
}

.m-anpc {
    display: block;
    background: var(--m-card);
    border: 1px solid var(--m-line);
    border-radius: 16px;
    padding: 14px 16px;
    text-decoration: none;
    color: var(--m-ink);

    b {
        display: block;
        font-size: 14px;
    }

    span {
        font-size: 12px;
        color: var(--m-muted);
    }

    .arr {
        float: right;
        color: var(--m-accent);
        font-weight: 700;
        font-size: 14px;
    }
}

.m-power {
    text-align: center;
    font-size: 11px;
    color: var(--m-muted);
    margin-top: 16px;
    letter-spacing: .04em;

    a {
        color: var(--m-accent);
        font-weight: 600;
        text-decoration: none;
    }
}

/* ===== detaliu preparat ===== */
.d-img {
    width: 100%;
    height: 190px;
    border-radius: 16px;
    object-fit: cover;
    background: var(--m-img-bg);
    border: 1px solid var(--m-line);
    margin-bottom: 14px;
}

.d-head {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 14px;

    h4 {
        font-size: 19px;
        margin: 6px 0 4px;
        font-weight: 600;
    }

    .m-price {
        font-size: 18px;
    }
}

.d-line {
    font-size: 12.5px;
    color: var(--m-muted);
    margin-bottom: 6px;
    font-variant-numeric: tabular-nums;
}

.d-desc {
    font-size: 13.5px;
    color: var(--m-muted);
    margin: 6px 0 12px;
}

.d-tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}
</style>
